import React, { useState } from 'react';
import {fetchResourceData} from '../Actions/Resources'
import { useSelector, useDispatch } from 'react-redux';
// import ReactTypingEffect from 'react-typing-effect';

function Resources() {
var filteredRes = []
const Res = useSelector(state => state.ResourceData.resources); 

const [showResBox, set_showResBox] =  useState(false);
console.log(showResBox);
const dispatch = useDispatch();
const resDiv = ( 
 Res  != undefined && showResBox ?
    <div class="resourcediv"> 
        <div>
            { <button type="button" class="btn btn-danger customClose" onClick={()=>set_showResBox(false)}>Close</button> }
            <br />
            <center>
            <p clas="lblresFound"><b style={{color:'red'}}> Found {Res.length} Resources</b> </p>
            </center>
        </div>
        <ul class="resList">
        {Res.map(item =>
                <li>
                Category : {item.category}<br />
                City : {item.city}<br />
                Contact : <a href={item.contact}>{item.contact} </a>  <br />
                Description : {item.descriptionandorserviceprovided} <br />
                Phone Number : {item.phonenumber}<br />
                State : {item.state} <br/>
            
                <br />
                </li>
                
                )}
    </ul>
   
  </div>
   :
   ""
)
  return(
   <div>
        {/* <ReactTypingEffect text="Hellow" /> */}
        <div className="search-appointments row justify-content-center my-4">
                <div className="col-md-6">  
                        <div className="input-group-append">
                        { 
                            <input id="SearchCity" 
                            aria-haspopup="true"
                            aria-expanded="false"
                            style={{color:'gray',backgroundColor:'rgba(211, 211, 211, 0.17)',borderColor:'transparent',maxWidth: '100%'}}
                            className="btn dropdown-toggle stateToogle"
                            onInput={() => set_showResBox(true)}
                            onChange={e => e.target.value !== "" ? dispatch(fetchResourceData(e.target.value)):""} 
                            type="text" 
                            class="form-control txtsearch" 
                            aria-label="Search City" 
                            placeholder=
                            "Search city to get the list of resources..." />
                       }
                        </div>
                </div>
            </div>
       {  
           showResBox ?
            resDiv
            :""
         
    }
    </div>
  )
}
export default Resources